import React, { useEffect, useState } from 'react';
import "./PromoItems.css";
import PromoCard from './PromoCard';
import { Divider } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import FrontConfigService from '../../../services/FrontConfigService';

import { useSelector } from 'react-redux';

export default function PromoItems(props) {
  const matches = useMediaQuery("(min-width:1150px)");
  const cart = useSelector(state => state.cartReducer);
  const [specialItems, setSpecialItems] = useState();
  const [smallScreenItems, setSmallScreenItems] = useState();

  useEffect(() => {
    getSpecialItems();
  }, [])

  const updateCart = (newItem, type, itemIndex) => {
    props.updateCart(newItem, type, itemIndex);
  }

  const getSpecialItems = async () => {
    const itemResponse = await FrontConfigService.getSpecialItems(cart.token);
    if (itemResponse.status === 200) {
      const items = itemResponse.json;
      if (items.length <= 8) {
        setSpecialItems(items);
        setSmallScreenItems(items.slice(0, 4));
      } else {
        const selected = items.sort(() => 0.5 - Math.random()).slice(0, 8);
        setSpecialItems(selected);
        setSmallScreenItems(selected.slice(0, 4))
      }
    }
  };

  function list() {
    if (Object.keys(cart).length !== 0) {
      return (
        <div className="PromoContainer" style={specialItems?.length <= 4 ? { gridTemplate: "1fr / 1fr 1fr 1fr 1fr" } : { gridTemplate: "1fr 1fr / 1fr 1fr 1fr 1fr" }}>
          {specialItems?.map((item, index) => {
            const inCart = [];
            cart.line_items.map(cartItem => {
              if (cartItem.variant_id === item.variant_id) {
                inCart.push(cartItem.quantity);
              }
            })
            return <PromoCard inCart={inCart} updateCart={updateCart} key={index} item={item} length={70} specialItems={specialItems.length} />
          }
          )}
        </div>
      )
    }
  };

  function mobileList() {
    if (Object.keys(cart).length !== 0) {
      return (
        <div className="MobileContainer" style={smallScreenItems?.length <= 2 ? { gridTemplate: "1fr / 1fr 1fr" } : { gridTemplate: "1fr 1fr / 1fr 1fr" }}>
          {smallScreenItems?.map((item, index) => {
            const inCart = [];
            cart.line_items.map(cartItem => {
              if (cartItem.variant_id === item.variant_id) {
                inCart.push(cartItem.quantity);
              }
            })
            return <PromoCard inCart={inCart} updateCart={updateCart} key={index} item={item} length={70} specialItems={smallScreenItems.length} />
          }
          )}
        </div>
      )
    }
  };

  return (
    <div style={{ height: '100%' }} >
      {
        matches ?
          list()
          :
          mobileList()
      }
    </div>
  )
};

